import { ApiService } from "../api.services";

const productService = {
  //Create Product
  CreateProduct: ({ name, code, minBalance, ledger, fee, rate, cycle }) => {
    return new Promise(function(resolve, reject) {
      ApiService.post("/ledgers/product/create", {
        name,
        code,
        minBalance,
        ledger,
        fee,
        interest: {
          rate,
          cycle
        }
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },

  //Get All Products
  GetProducts: async () => {
    return await ApiService.get("/ledgers/product")
      .then(res => {
        return Promise.resolve(res.data);
      })
      .catch(error => {
        return Promise.reject(error.response.data);
      });
  },

  //Update Product
  UpdateProduct: ({ name, code, minBalance, ledger, fee, rate, cycle, id }) => {
    return new Promise(function(resolve, reject) {
      ApiService.put(`/ledgers/product/${id}`, {
        name,
        code,
        minBalance,
        ledger,
        fee,
        interest: {
          rate,
          cycle
        }
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  }
};

export { productService };
